import { CustomerSapExportSearchBody } from "@/common/api/customer-sap-export/use-customer-sap-export-search.query";
import { dateRangeInputToIso } from "@/components/ui/date-range-picker-input";
import { DateFormat } from "@/store/user-config-store";

export function buildCustomerSapExportSearchBody({
  externalBody,
  filterValues,
  dateFormat,
}: {
  externalBody: CustomerSapExportSearchBody | undefined;
  filterValues: Record<string, string[]>;
  dateFormat: DateFormat;
}): CustomerSapExportSearchBody {
  const { exportPeriod, ...filters } = filterValues;
  const from = dateRangeInputToIso(exportPeriod?.[0] ?? "", dateFormat);
  const to = dateRangeInputToIso(exportPeriod?.[1] ?? "", dateFormat);
  const activeFilters = Object.fromEntries(Object.entries(filters).filter(([, values]) => values.length > 0));

  return {
    ...externalBody,
    ...activeFilters,
    ...(from && { lastExportAtFrom: from }),
    ...(to && { lastExportAtTo: to }),
  };
}
